module.exports = __webpack_public_path__ + "img/bgHero2.9eeead6b.jpg";